var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleStoreMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 54,
    viewBox: "0 0 180 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xrcib6g1ka)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.333 53.507H6.667C2.933 53.507 0 50.595 0 46.889V7.183C0 3.477 2.933.566 6.667.566h166.666c3.734 0 6.667 2.911 6.667 6.617V46.89c0 3.706-2.933 6.618-6.667 6.618z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.011 14.07c0 1.059-.266 1.985-.93 2.646-.798.794-1.729 1.191-2.925 1.191-1.197 0-2.127-.397-2.925-1.19-.797-.795-1.196-1.72-1.196-2.911s.399-2.117 1.196-2.911c.798-.794 1.728-1.191 2.925-1.191.532 0 1.063.132 1.595.397.532.264.93.53 1.197.926l-.665.662c-.532-.662-1.197-.927-2.127-.927-.798 0-1.595.265-2.127.927-.665.529-.93 1.323-.93 2.249 0 .926.265 1.72.93 2.249.665.53 1.33.926 2.127.926.93 0 1.595-.264 2.26-.926.399-.397.665-.926.665-1.588h-2.925v-1.058h3.855v.53zm6.115-3.308h-3.59v2.514h3.324v.926h-3.323v2.514h3.589v1.059h-4.653V9.836h4.653v.926zm4.387 7.013h-1.064v-7.012h-2.26v-.927h5.584v.926h-2.26v7.013zm6.115 0V9.836h1.063v7.939h-1.063zm5.583 0h-1.063v-7.012h-2.26v-.927h5.45v.926h-2.26v7.013h.133zm12.629-1.059c-.798.794-1.728 1.191-2.925 1.191-1.196 0-2.127-.397-2.924-1.19-.798-.795-1.197-1.72-1.197-2.911s.4-2.117 1.197-2.911 1.728-1.191 2.924-1.191c1.197 0 2.127.397 2.925 1.19.797.795 1.196 1.72 1.196 2.912 0 1.19-.398 2.116-1.196 2.91zm-5.052-.661c.532.529 1.33.926 2.127.926.798 0 1.595-.265 2.127-.926.532-.53.93-1.323.93-2.25 0-.926-.265-1.72-.93-2.249-.532-.529-1.33-.926-2.127-.926-.797 0-1.595.265-2.127.926a3.184 3.184 0 0 0-.93 2.25c0 .926.266 1.72.93 2.249zm7.711 1.72V9.836h1.196l3.855 6.219V9.836h1.064v7.939h-1.064l-4.121-6.483v6.483h-.93zM90.528 29.418c-3.19 0-5.716 2.381-5.716 5.69 0 3.175 2.526 5.688 5.716 5.688 3.19 0 5.716-2.381 5.716-5.689 0-3.44-2.525-5.689-5.716-5.689zm0 8.997c-1.728 0-3.19-1.456-3.19-3.44 0-1.985 1.462-3.44 3.19-3.44s3.19 1.323 3.19 3.44c0 1.984-1.462 3.44-3.19 3.44zm-12.363-8.997c-3.19 0-5.716 2.381-5.716 5.69 0 3.175 2.526 5.688 5.716 5.688 3.19 0 5.717-2.381 5.717-5.689 0-3.44-2.526-5.689-5.717-5.689zm0 8.997c-1.728 0-3.19-1.456-3.19-3.44 0-1.985 1.462-3.44 3.19-3.44 1.729 0 3.19 1.323 3.19 3.44 0 1.984-1.461 3.44-3.19 3.44zM63.41 31.138v2.381h5.716c-.133 1.324-.665 2.382-1.33 3.044-.797.793-2.126 1.72-4.386 1.72-3.59 0-6.248-2.779-6.248-6.351s2.791-6.35 6.248-6.35c1.86 0 3.323.793 4.387 1.72l1.728-1.72C68.062 24.257 66.2 23.2 63.543 23.2c-4.786 0-8.907 3.969-8.907 8.732s4.121 8.732 8.907 8.732c2.658 0 4.52-.794 6.115-2.514 1.595-1.587 2.127-3.837 2.127-5.557 0-.529 0-1.058-.133-1.455H63.41zm60.352 1.852c-.532-1.323-1.861-3.572-4.786-3.572-2.924 0-5.317 2.25-5.317 5.69 0 3.175 2.393 5.688 5.583 5.688 2.526 0 4.121-1.587 4.653-2.514l-1.861-1.323c-.665.927-1.462 1.588-2.792 1.588-1.329 0-2.127-.53-2.791-1.72l7.577-3.175-.266-.662zm-7.71 1.852c0-2.116 1.728-3.307 2.924-3.307.931 0 1.861.53 2.127 1.19l-5.051 2.117zm-6.248 5.425h2.526V23.73h-2.526v16.538zm-3.988-9.658c-.665-.662-1.728-1.323-3.058-1.323-2.791 0-5.45 2.513-5.45 5.689 0 3.175 2.526 5.557 5.45 5.557 1.33 0 2.393-.662 2.925-1.323h.133v.793c0 2.117-1.197 3.308-3.058 3.308-1.462 0-2.525-1.058-2.791-1.984l-2.127.926c.664 1.455 2.26 3.307 5.051 3.307 2.925 0 5.318-1.72 5.318-5.821V29.683h-2.393v.926zm-2.925 7.806c-1.728 0-3.19-1.456-3.19-3.44 0-1.985 1.462-3.44 3.19-3.44s3.058 1.455 3.058 3.44c0 1.984-1.33 3.44-3.058 3.44zm32.436-14.686h-5.982v16.538h2.526V34.05h3.456c2.792 0 5.451-1.985 5.451-5.16 0-3.176-2.659-5.16-5.451-5.16zm.133 7.938h-3.589v-5.689h3.589c1.861 0 2.925 1.588 2.925 2.778-.133 1.456-1.197 2.911-2.925 2.911zm15.288-2.381c-1.861 0-3.723.793-4.387 2.513l2.26.927c.531-.927 1.329-1.191 2.26-1.191 1.329 0 2.525.794 2.658 2.117v.132c-.399-.264-1.462-.661-2.525-.661-2.393 0-4.786 1.323-4.786 3.704 0 2.25 1.994 3.705 4.121 3.705 1.728 0 2.526-.794 3.19-1.588h.133v1.323h2.393v-6.35c-.266-2.911-2.526-4.631-5.317-4.631zm-.266 9.129c-.798 0-1.994-.397-1.994-1.456 0-1.323 1.462-1.72 2.658-1.72 1.064 0 1.596.265 2.26.53-.266 1.587-1.595 2.646-2.924 2.646zm13.958-8.732-2.792 7.144h-.133l-2.924-7.144h-2.659l4.387 10.055-2.526 5.557h2.526l6.78-15.612h-2.659zm-22.333 10.584h2.526V23.73h-2.526v16.538z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.825 10.498c-.399.397-.532 1.058-.532 1.852v29.24c0 .794.266 1.455.665 1.852l.133.132 16.484-16.406v-.264l-16.75-16.406z",
    fill: "url(#58nmr5j3kb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.892 32.725-5.45-5.424v-.397l5.45-5.425.133.133 6.514 3.704c1.861 1.059 1.861 2.779 0 3.837l-6.647 3.572z",
    fill: "url(#rx30v1t8qc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.025 32.593-5.583-5.557-16.617 16.539c.665.661 1.595.661 2.792.132l19.408-11.114",
    fill: "url(#543dvgdgcd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.025 21.48 16.617 10.497c-1.197-.662-2.127-.53-2.792.132l16.617 16.406 5.583-5.557z",
    fill: "url(#2ma1742gue)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.892 32.46 16.617 43.31c-1.064.661-1.994.53-2.659 0l-.133.132.133.133c.665.529 1.595.661 2.659 0L35.892 32.46z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.825 43.31c-.399-.397-.532-1.059-.532-1.852v.132c0 .794.266 1.455.665 1.852v-.132h-.133zm28.714-14.554-6.647 3.705.133.132 6.514-3.704c.93-.53 1.33-1.191 1.33-1.853 0 .662-.532 1.191-1.33 1.72z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m16.617 10.63 25.922 14.686c.797.53 1.33 1.059 1.33 1.72 0-.662-.4-1.323-1.33-1.852L16.617 10.498c-1.861-1.059-3.324-.265-3.324 1.852v.132c0-1.984 1.463-2.91 3.324-1.852z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "58nmr5j3kb",
    x1: 28.98,
    y1: 12.099,
    x2: 6.775,
    y2: 34.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rx30v1t8qc",
    x1: 44.977,
    y1: 27.038,
    x2: 12.811,
    y2: 27.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "543dvgdgcd",
    x1: 33.004,
    y1: 30.074,
    x2: 2.894,
    y2: 60.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2ma1742gue",
    x1: 9.7,
    y1: 0.808,
    x2: 23.146,
    y2: 14.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xrcib6g1ka"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .566)",
    d: "M0 0h180v52.941H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStoreMobile);
export default __webpack_public_path__ + "static/media/googleStoreMobile.3804c2686c6ead19e02ad2cd0f730201.svg";
export { ForwardRef as ReactComponent };